import { useEnvironmentGroupsQuery } from './__generated__/queries.generated';

function useEnvironmentGroups(teamId: string, skip = false) {
  const { data, loading, refetch } = useEnvironmentGroupsQuery({
    variables: { teamId },
    fetchPolicy: 'cache-first',
    skip: skip || !teamId,
  });

  return { environmentGroups: data?.environmentGroups || [], loading, refetch };
}

export { useEnvironmentGroups };
